"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splide_1 = __importDefault(require("@splidejs/splide"));
var SplideSlider = /** @class */ (function () {
    function SplideSlider(selector) {
        this.selector = selector;
        this.sliders = document.querySelectorAll(this.selector);
        if (this.sliders.length < 1)
            return;
        // Configure slider defaults
        splide_1.default.defaults = {
            i18n: {
                prev: 'Previous slide',
                next: 'Next slide'
            }
        };
        // Configure each slider on the page
        this.sliders.forEach(function (element) {
            var splide = new splide_1.default(element, {
                perPage: 1,
                width: '22rem',
                breakpoints: {
                    1200: {
                        width: '16.5rem'
                    },
                    992: {
                        focus: 'center',
                        width: '16.5rem'
                    }
                }
            });
            // Custom pagination
            splide.on('pagination:mounted', function (data) {
                data.items.forEach(function (item) {
                    item.button.textContent = String(item.page + 1 + ' / ' + splide.length);
                });
            });
            splide.mount();
        });
    }
    return SplideSlider;
}());
exports.default = SplideSlider;
